import { ApiContext } from "@/hooks/api/base"

export async function signedIdsForUploadedFiles(
  context: ApiContext,
  newFiles: File[],
  existingSignedIds: string[] = []
): Promise<string[]> {
  const apiRoot = (process.env.NEXT_PUBLIC_API_URL || "http://localhost:3000/api/").replace("/api/", "")
  const { uploadFileDirectly } = await import("@/utils/direct-upload")
  const newSignedIds = await Promise.all(newFiles.map((file) => uploadFileDirectly(file, apiRoot, context.token)))

  return [...existingSignedIds, ...newSignedIds]
}
